//  ----------      START   IMPORT  BLOCK       ----------
import React from 'react';
import { Card } from 'react-bootstrap';
//  Context
import { useLanguage } from '../../API/Context/LanguageContext';
//  ----------      END   IMPORT  BLOCK       ----------

interface MapWidgetProps {
  lat?: number;
  lng?: number;
}

const MapWidget: React.FC<MapWidgetProps> = ({ lat, lng }) => {
  const { lan } = useLanguage();

  // Strict coordinate validation
  const isValidCoordinate = 
    typeof lat === 'number' && 
    typeof lng === 'number' && 
    !isNaN(lat) && 
    !isNaN(lng) &&
    !(lat === 0 && lng === 0) &&
    lat >= -90 && lat <= 90 &&
    lng >= -180 && lng <= 180;

  const embedUrl = isValidCoordinate
    ? `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`
    : null;

  return (
    <Card className="shadow-sm mb-3 border-0">
      <Card.Header className="bg-light fw-bold py-2">
        {lan === 0 ? 'Ubicación de la Clínica' : 'Clinic Location'}
      </Card.Header>
      <Card.Body style={{ padding: 0, height: '350px' }} className="position-relative">
        {isValidCoordinate && embedUrl ? (
          <iframe
            key={`${lat}-${lng}`} // Forces iframe to re-render on medic change
            title="Clinic Location Map"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            src={embedUrl}
          />
        ) : (
          <div className="d-flex justify-content-center align-items-center h-100 text-muted p-3 text-center bg-light">
            {lan === 0 
              ? 'Selecciona un perfil con dirección registrada para ver su ubicación.' 
              : 'Select a profile with a registered address to view its location.'}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default MapWidget;